import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";
import styles from "./styles.module.css";
import { useState } from "react";

const Step3 = ({
  handleVoltar,
  signatarios,
  pdfUrl,
  fileKey,
  handleEnviar
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <DialogContent>
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            textAlign: "center",
          }}
        >
          <div style={{ width: "16rem" }}>
            <h3 style={{ color: "#18316e" }}>Contrato</h3>
            <br />
            <div style={{ maxWidth: "15rem" }}>
              <Button
                variant="contained"
                fullWidth
                className={styles.btn_visualizador}
                startIcon={<PreviewIcon />}
                onClick={handleOpen}
              >
                Vizualize o Contrato
              </Button>
            </div>
          </div>
          <hr />
          <div style={{ width: "16rem" }}>
            <h3 style={{ color: "#18316e" }}>Signatários</h3>
            <br />
            {signatarios?.map((item, index) => {
              return (
                <div key={index}>
                  <h4>{item.nome}</h4>
                </div>
              );
            })}
          </div>
        </div>
        <DialogActions className={styles.container_btn}>
          <Button
            className={styles.btn_close}
            onClick={handleVoltar}
            variant="outlined"
          >
            Voltar
          </Button>
          <Button
            className={styles.btn_avancar}
            onClick={handleEnviar}
            variant="contained"
          >
            Enviar
          </Button>
        </DialogActions>
      </DialogContent>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xl">
        <div style={{ width: "100%", height: "90vh" }}>
          <iframe
            key={fileKey}
            src={pdfUrl}
            title="Pré-visualização do PDF"
            style={{ width: "100%", height: "100%", border: "none" }}
          />
        </div>
        <div style={{ padding: "1rem" }}>
          <DialogActions className={styles.container_btn}>
            <Button
              className={styles.btn_close}
              onClick={handleClose}
              variant="outlined"
            >
              Fechar
            </Button>
            <Button
              className={styles.btn_avancar}
              onClick={handleEnviar}
              variant="contained"
            >
              Enviar
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
};

export default Step3;
